import React from 'react';
import '../styles/ExpatriateSupport.css';
import expatImage from '../assets/expat-support-illustration.png';

export default function ExpatriateSupport() {
  return (
    <div className="expat-page container py-5">
      <div className="row align-items-center g-5">
        {/* Left: Textual Content */}
        <div className="col-lg-7">
          <h1>Support for Expatriates</h1>
          <p className="lead">
            Moving to Malaysia for work? <strong>Let us make it easy.</strong>
          </p>
          <p>
            Whether you're an expatriate professional or a company bringing talent into Malaysia, Reans Consulting helps you navigate immigration requirements with confidence. We offer a full suite of services to ensure your relocation and employment processes are smooth, lawful, and worry-free.
          </p>

          {/* Assistance */}
          <section className="mb-5">
            <h3 className="section-heading"><i className="bi bi-globe2 me-2 text-success"></i>What We Help With</h3>
            <div className="check-cards">
              <div className="card-item"><i className="bi bi-file-earmark-check-fill text-success me-2"></i> Employment Passes (EP)</div>
              <div className="card-item"><i className="bi bi-people-fill text-success me-2"></i> Dependent & Social Visit Passes</div>
              <div className="card-item"><i className="bi bi-arrow-repeat text-success me-2"></i> Visa processing & renewals</div>
              <div className="card-item"><i className="bi bi-clipboard-check-fill text-success me-2"></i> Compliance & payroll setup</div>
            </div>
          </section>

          {/* Documents */}
          <section className="mb-5">
            <h3 className="section-heading"><i className="bi bi-file-earmark-text me-2 text-info"></i>Documents You'll Need</h3>
            <div className="check-cards">
              <div className="card-item"><i className="bi bi-passport text-info me-2"></i> Valid passport (all pages)</div>
              <div className="card-item"><i className="bi bi-patch-check-fill text-info me-2"></i> Certified education & marital certificates</div>
              <div className="card-item"><i className="bi bi-camera-fill text-info me-2"></i> Blue background photo</div>
              <div className="card-item"><i className="bi bi-person-badge-fill text-info me-2"></i> Employment contract & job details</div>
              <div className="card-item"><i className="bi bi-file-earmark-bar-graph-fill text-info me-2"></i> Tax clearance docs (if applicable)</div>
            </div>
          </section>

          {/* Why Choose Us */}
          <section>
            <h3 className="section-heading"><i className="bi bi-patch-check me-2 text-primary"></i>Why Choose Reans?</h3>
            <p>
              With Reans Consulting, you're not just getting immigration support—you're gaining a strategic partner. We're trusted by both multinational firms and SMEs for our rapid processes, reliable documentation support, and deep understanding of Malaysian regulations.
            </p>
            <div className="check-cards">
              <div className="card-item"><i className="bi bi-check-circle-fill text-primary me-2"></i> Stress-free end-to-end process management</div>
              <div className="card-item"><i className="bi bi-lightning-fill text-primary me-2"></i> Fast approvals & personalized support</div>
              <div className="card-item"><i className="bi bi-shield-check text-primary me-2"></i> 100% compliance with immigration laws</div>
            </div>
          </section>
        </div>

        {/* Right: Illustration */}
        <div className="col-lg-5 d-none d-lg-block">
          <img src={expatImage} alt="Expatriate Support Illustration" className="img-fluid rounded shadow" />
        </div>
      </div>
    </div>
  );
}
